import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    user: {
      email_id: "",
      userrole: null,
      access_token:""
    },
    isLoggedIn: false,
    isAuthenticated: false,
  },
}

export const userSlice = createSlice({
  name: "user",

  initialState,

  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
      state.isAuthenticated = true;
    },

    signout: (state) => {
      state.user = {
        email_id: "",
        userrole: null,
        access_token:"",
      };
      state.isLoggedIn = false;
      state.isAuthenticated = false;
    },

    resetUser: () => initialState
  },
});

export const { login, signout, resetUser } = userSlice.actions;

export const selectUser = (state) => state.user;

export default userSlice.reducer;
